import { TraceableProcess, TrackingEvent } from '../../../services/analytics/model';

export class TenantSignedUp implements TrackingEvent {
  public readonly category = TraceableProcess.USER_PROFILE;
  public readonly action = 'Tenant Signed Up';

  constructor(public readonly phone: string, public readonly source?: string, public readonly origin?: string) {}
}
